import { useQuery } from "react-query";
import apiRoutes from "../../api/apiRoutes";
import ApiCall from "../../api/network";

const fetchAllCities = async (page) => {
  return await ApiCall.any(apiRoutes.getCities, page ? page : {});
};

export const useCities = (page) => {
  return useQuery(["cities", page], () => fetchAllCities(page), {
    staleTime: 60 * (60 * 1000),
  });
};

const fetchAllCountries = async (page) => {
  return await ApiCall.any(apiRoutes.getCountryFeatured, page ? page : {});
  // return await ApiCall.any(apiRoutes.getCountry, page ? page : {});
};

export const useCountry = (page) => {
  return useQuery(["countries", page], () => fetchAllCountries(page), {
    staleTime: 60 * (60 * 1000),
  });
};

const fetchCountries = async (page) => {
  return await ApiCall.any(apiRoutes.getCountry, page ? page : {});
};

export const useAllCountry = (page) => {
  return useQuery(["countries-all", page], () => fetchCountries(page), {
    staleTime: 60 * (60 * 1000),
  });
};
